import React, { useEffect, useRef } from "react";
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
import moment from "moment";

export default function SelectedDate({ anchorRef, selectedRange, onApply, onClose }) {
  const inputRef = useRef(null);

  useEffect(() => {
    const $input = $(inputRef.current);

    $input.daterangepicker(
      {
        opens: "right",
        autoUpdateInput: false,
        alwaysShowCalendars: true,
        
        parentEl: "body", 
        locale: {
          format: "YYYY-MM-DD",
          cancelLabel: "Clear",
          applyLabel: "Apply",
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      }
    );

    const picker = $input.data("daterangepicker");

    $input.on("apply.daterangepicker", (ev, picker) => {
      onApply?.({
        startDate: picker.startDate.toDate(),
        endDate: picker.endDate.toDate(),
      });
    });

    $input.on("hide.daterangepicker", () => {
      onClose?.();
    });

    return () => {
      $input.off("apply.daterangepicker hide.daterangepicker");
      picker?.remove();
    };
  }, [onApply, onClose]);

  useEffect(() => {
    const picker = $(inputRef.current).data("daterangepicker");
    if (!picker) return;

    if (selectedRange?.startDate) {
      picker.setStartDate(moment(selectedRange.startDate));
      picker.setEndDate(moment(selectedRange.endDate || selectedRange.startDate));
    }
  }, [selectedRange]);

  useEffect(() => {
    const $anchor = $(anchorRef.current);
    if (!$anchor) return;

    const handleClick = () => {
      const picker = $(inputRef.current).data("daterangepicker");
      picker.show();
    };

    $anchor.on("click", handleClick);

    return () => {
      $anchor.off("click", handleClick);
    };
  }, [anchorRef]);

  return <input ref={inputRef} type="text" className="absolute opacity-0 w-px h-px" readOnly />;
}
